export default function Release20230109() {
    return (
        <>
            <p>
                Hiper blev stiftet i 2015 med en klar ambition om at levere højhastighedsforbindelser og kundeservice af høj kvalitet til de danskere,
                der ønsker en enkel og hurtig internetforbindelse.
                I dag har internetudbyderen flere priser i ryggen for alt fra &lsquo;Mest værdi for pengene&rsquo; til &lsquo;Flest vil anbefale&rsquo;,
                som også kommer til udtryk i en Trustpilot-score på 4,6.
                Og med en kundebase, der netop har rundet 100.000, er meldingen ifølge selskabets direktør, Mads Hein, ikke til at tage fejl af.
            </p>
            <p>
                &ldquo;Det er en kæmpe milepæl, og jeg er enormt stolt over, at vi er nået hertil.
                       Hiper er sat i verden for at tilbyde lynhurtigt og driftssikkert internet til en konkurrencedygtig pris og med en sublim kundeservice,
                       og det synes jeg i dén grad, at vores 100.000 kunder er et vidnesbyrd om, at vi lykkes med.
                       Nu ser jeg frem til sammen med teamet at fortsætte med at styrke Hipers position som det foretrukne valg for de danskere,
                       der ønsker en god og enkel bredbåndsoplevelse hele vejen rundt,&rdquo; siger Mads Hein.
            </p>
            <p>
                <strong>Fortsat fokus på digitalisering og fiberdækning</strong><br/>
                En stor del af Hipers salg foregår allerede i dag digitalt, og i de kommende år vil man arbejde målrettet med at digitalisere forretningen yderligere gennem en række initiativer,
                der skal gøre kundeoplevelsen endnu bedre.
            </p>
            <p>
                &ldquo;Vi lever i en tid, hvor mange kunder orienterer sig digitalt og sætter pris på at kunne betjene sig selv online.
                       Derfor vil vi i de kommende år fokusere på at forbedre kundeoplevelsen yderligere ved at gøre os endnu mere tilgængelige online
                       og skabe intuitive digitale kunderejser,&rdquo; fortæller Mads Hein.
            </p>
            <p>
                Også fiber vil fortsat være en høj prioritet for Hiper, som i løbet af 2021 og 2022 har åbnet for salg via nogle af landets største fibernet.
            </p>
            <p>
                &ldquo;Vi ser en enorm stor appetit på fiber blandt vores kunder, og derfor bliver fiberdækning også de kommende år en høj prioritet for os.
                       Selvom vi allerede er stærke på fiber og har aftaler med størstedelen af de danske fibernet, vil vi arbejde målrettet på at åbne yderligere op,
                       så vi løbende kan tilbyde endnu flere kunder landet over adgang til det lynhurtige, stabile og driftssikre internet,&rdquo; uddyber Mads Hein.
            </p>
            <p>
                <strong>Vigtig vækstmotor for Nuuday</strong><br/>
                Hiper er en del af Nuuday, og her er selskabet en vigtig drivkraft for væksten inden for det strategisk vigtige område højhastighedsbredbånd.
            </p>
            <p>
                &ldquo;Hiper har leveret en enorm flot vækstkurve og har været helt afgørende for at skaffe internetkunder ind i forretningen.
                       De spiller en vigtig rolle i, at Nuuday fastholder en stærk position på højhastighedsbredbånd
                       og når succesfuldt i mål med strategien om at blive Danmarks mest innovative og digitale tjenesteudbyder, der leverer de bedste kundeoplevelser,&rdquo;
                       slutter EVP i Nuuday, Jens Grønlund, der er ansvarlig for Nuudays digitale brands, herunder Hiper, Telmore, eesy og Relatel.
            </p>
            <p>
                <strong>Om Hiper</strong><br/>
                Hiper leverer lynhurtigt bredbånd og dækker over to millioner danske husstande med 1.000 Mbit.
                Hiper er tre år i træk blevet kåret til den internetudbyder, der giver kunderne mest værdi for pengene af analyseinstituttet Loyalty Group
                og løb også i 2022 med sejren for prisen &lsquo;Flest vil anbefale&rsquo;.
            </p>
        </>
    )
}
